import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {
    
    ChangePassword(oldPassword,newPassword,confirmationPassword){
        return axios.post('/api/users/password/change', {oldPassword: oldPassword, newPassword: newPassword, confirmationPassword:confirmationPassword})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.simple(i18n.t('services.users.changePassword'))
                return response.data;
            }
        })
        .catch(error => {console.log(error);})

    },

    getUserInfo (id) {
        return axios.get('/api/users/info/',{ params: { id: id } })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },

    findLastSearches () {
        return axios.get('/api/users/last-search/')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },

    getCurrentUserImage () {
        return axios.get('/api/users/user-image' )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },

    setLanguage(code){
        return axios.post("/api/users/set/language/"+code)
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {console.log(error);})
    },

    uploadImage(formData,imageName){
        const imageData = {
            imageAsBase64:formData ,
            imageName:imageName
        }
        return axios.post("/api/image/user/upload-base64/", imageData )
        .then(response => {
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {console.log(error);})
    },

    deleteImage(){
        return axios.post("/api/image/remove/file/")
        .then(response => {
            if (response && response.data) { 
                return response.data;
            }
        })
        .catch(error => {console.log(error);})
    },
    
}